import React from "react";
import './index.css';
import { Link } from "react-router-dom";
import { TfiAndroid } from "react-icons/tfi";
import { FiArrowRight } from "react-icons/fi";
import Footer from './Footer';
import logo from '../Assets/02.png';
function Services(){
    return(
        <div className="Services_main">
            <div className="about_main1a">
                <div className="About_div1">
                    <div className="About_div1a">
                        <span className="div1_h1">HOME</span>
                        <span className="div1_h1a">-</span>
                        <span className="div1_h1a">SERVICES</span>
                    </div>
                    <div className="div1_h2">SERVICES</div>
                </div>
            </div>
            <div className="Service_div2">
            <div className="home_div2ba">
                <div className="col-lg">
                    <div className="Service_blocks">
                        <div className="Service_blocks1">
                            <div className="Service_icon">
                                <div className="icon1">
                                    <div className="icon">
                                        <TfiAndroid style={{color:"white"}} />
                                    </div>
                                </div>
                                <div className="service_icon_two"></div>
                                <div className="service_icon_two1"></div> 
                            </div>
                            <div className="Service_text">
                                <h4 className="Service_text_h4">
                                    <a>App Development</a>
                                </h4>
                                <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                            </div>
                            <div style={{height:"60px"}}>
                                <Link to='/Services'>
                                    <div className="service_icon">
                                        <FiArrowRight className="sricon"/>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="col-lg">
                        <div className="Service_blocks">
                            <div className="Service_blocks1">
                                <div className="Service_icon">
                                    <div className="icon1">
                                        <div className="icon">
                                            <TfiAndroid style={{color:"white"}} />
                                        </div>
                                    </div>
                                    <div className="service_icon_two"></div>
                                    <div className="service_icon_two1"></div> 
                                </div>
                                <div className="Service_text">
                                    <h4 className="Service_text_h4">
                                        <a>App Development</a>
                                    </h4>
                                    <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                                </div>
                                <div style={{height:"60px"}}>
                                    <Link to='/Services'>
                                        <div className="service_icon">
                                            <FiArrowRight className="sricon"/>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div className="col-lg">
                            <div className="Service_blocks">
                                <div className="Service_blocks1">
                                    <div className="Service_icon">
                                        <div className="icon1">
                                            <div className="icon">
                                                <TfiAndroid style={{color:"white"}} />
                                            </div>
                                        </div>
                                        <div className="service_icon_two"></div>
                                            <div className="service_icon_two1"></div> 
                                    </div>
                                    <div className="Service_text">
                                        <h4 className="Service_text_h4">
                                            <a>App Development</a>
                                        </h4>
                                        <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                                    </div>
                                    <div style={{height:"60px"}}>
                                        <Link to='/Services'>
                                            <div className="service_icon">
                                                <FiArrowRight className="sricon"/>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <div className="home_div2ba">
                <div className="col-lg">
                    <div className="Service_blocks">
                        <div className="Service_blocks1">
                            <div className="Service_icon">
                                <div className="icon1">
                                    <div className="icon">
                                        <TfiAndroid style={{color:"white"}} />
                                    </div>
                                </div>
                                <div className="service_icon_two"></div>
                                <div className="service_icon_two1"></div> 
                            </div>
                            <div className="Service_text">
                                <h4 className="Service_text_h4">
                                    <a>App Development</a>
                                </h4>
                                <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                            </div>
                            <div style={{height:"60px"}}>
                                <Link to='/Services'>
                                    <div className="service_icon">
                                        <FiArrowRight className="sricon"/>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="col-lg">
                        <div className="Service_blocks">
                            <div className="Service_blocks1">
                                <div className="Service_icon">
                                    <div className="icon1">
                                        <div className="icon">
                                            <TfiAndroid style={{color:"white"}} />
                                        </div>
                                    </div>
                                    <div className="service_icon_two"></div>
                                    <div className="service_icon_two1"></div> 
                                </div>
                                <div className="Service_text">
                                    <h4 className="Service_text_h4">
                                        <a>App Development</a>
                                    </h4>
                                    <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                                </div>
                                <div style={{height:"60px"}}>
                                    <Link to='/Services'>
                                        <div className="service_icon">
                                            <FiArrowRight className="sricon"/>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div className="col-lg">
                            <div className="Service_blocks">
                                <div className="Service_blocks1">
                                    <div className="Service_icon">
                                        <div className="icon1">
                                            <div className="icon">
                                                <TfiAndroid style={{color:"white"}} />
                                            </div>
                                        </div>
                                        <div className="service_icon_two"></div>
                                            <div className="service_icon_two1"></div> 
                                    </div>
                                    <div className="Service_text">
                                        <h4 className="Service_text_h4">
                                            <a>App Development</a>
                                        </h4>
                                        <p className="Service_text_p">Providing legal advice, contract drafting, compliance assistance.</p>
                                    </div>
                                    <div style={{height:"60px"}}>
                                        <Link to='/Services'>
                                            <div className="service_icon">
                                                <FiArrowRight className="sricon"/>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer/>
        </div>
    );
}
export default Services;